import { useEffect, useMemo, useState } from 'react';
import { useFilters } from './useFilters';
import { filterEmptyFilters, objectToString } from '../helpers/helpers';

export const useNestedSort = (
  sortObj: { [key: string]: string | null },
  nestedId: string,
  nestedKey: string
) => {
  type typeSortObj = typeof sortObj;
  const [sort, setSort] = useState<typeSortObj>(sortObj);
  const { applyNestedFilter } = useFilters();

  const manageTripleSortState = (key: string) => {
    const sortType = sort[key];
    switch (sortType) {
      case 'default':
        return setSort({ [key]: 'desc' });
      case 'asc':
        return setSort({ [key]: 'default' });
      case 'desc':
        return setSort({ [key]: 'asc' });
      default:
        return setSort({ [key]: 'desc' });
    }
  };

  const manageSortState = (key: string) => {
    const sortType = sort[key] || 'desc';
    if (sortType === 'asc') {
      return setSort({ [key]: 'desc' });
    }
    return setSort({ [key]: 'asc' });
  };

  const doSort = (surveyId: string, key: string) => {
    const filteredSorts = filterEmptyFilters(sort);
    const filterString = objectToString(filteredSorts);
    if (filterString) {
      return applyNestedFilter({ sortOrder: filterString }, surveyId, key);
    }
  };

  const getSortAscState = useMemo(() => {
    return Object.keys(sort).reduce((res: { [key: string]: boolean }, key: string) => {
      const state = sort[key] === 'asc';
      return { ...res, [key]: state };
    }, {});
  }, [sort]);

  useEffect(() => {
    doSort(nestedId, nestedKey);
  }, [nestedId, nestedKey, sort]);

  return { sort, getSortAscState, manageSortState, doSort, manageTripleSortState };
};
